var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Place_1;
import { xsd } from 'lincd-xsd/ontologies/xsd';
import { Literal } from 'lincd/models';
import { literalProperty, objectProperty } from 'lincd/shapes/SHACL';
import { schema } from '../ontologies/schema.js';
import { linkedShape } from '../package.js';
import { Thing } from './Thing.js';
let Place = Place_1 = class Place extends Thing {
    get latitude() {
        return this.getValue(schema.latitude);
    }
    set latitude(val) {
        this.overwrite(schema.latitude, new Literal(val));
    }
    get longitude() {
        return this.getValue(schema.longitude);
    }
    set longitude(val) {
        this.overwrite(schema.longitude, new Literal(val));
    }
    get containedInPlace() {
        return this.getOneAs(schema.containedInPlace, Place_1);
    }
    set containedInPlace(val) {
        this.overwrite(schema.containedInPlace, val.namedNode);
    }
};
Place.targetClass = schema.Place;
__decorate([
    literalProperty({
        path: schema.latitude,
        maxCount: 1,
        datatype: xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Place.prototype, "latitude", null);
__decorate([
    literalProperty({
        path: schema.longitude,
        maxCount: 1,
        datatype: xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Place.prototype, "longitude", null);
__decorate([
    objectProperty({
        path: schema.containedInPlace,
        shape: Place,
        maxCount: 1,
    }),
    __metadata("design:type", Place),
    __metadata("design:paramtypes", [Place])
], Place.prototype, "containedInPlace", null);
Place = Place_1 = __decorate([
    linkedShape({
        description: 'Entities that have a somewhat fixed, physical extension. Represents locations with coordinates, addresses, and containment relationships. (location, venue, site)',
    })
], Place);
export { Place };
//# sourceMappingURL=Place.js.map